// Compteur d'avis en attente de modération (masqués) : alimente les pastilles [data-pending-ratings]
// du menu (Configurations) et du lien « Avis », ainsi que le texte [data-pending-ratings-label] de la
// page des avis. Le total vient de la liste des avis filtrée sur visible=0 (limit=1 : seul le total
// nous intéresse). Tout reste masqué à 0 ou en cas d'erreur. Rappelable après une modération via
// window.refreshPendingRatings().
const refreshPendingRatings = async () => {
    const badges = document.querySelectorAll("[data-pending-ratings]");
    const labels = document.querySelectorAll("[data-pending-ratings-label]");
    if (!(badges.length || labels.length) || typeof Routing === "undefined") return;

    try {
        const response = await fetch(Routing.generate("shop_ratings_search", {visible: 0, limit: 1}));
        const result = await response.json();
        const total = response.ok ? Number(result?.data?.total ?? 0) : 0;

        badges.forEach((badge) => {
            badge.textContent = total > 99 ? "99+" : total;
            badge.title = `${total} avis en attente de modération`;
            badge.classList.toggle("hidden", !total);
        });
        labels.forEach((label) => {
            label.textContent = total > 1 ? `${total} avis à modérer` : "1 avis à modérer";
            label.classList.toggle("hidden", !total);
        });
    } catch (e) {
        // Indicateur secondaire : on ne perturbe pas la page.
    }
};

window.refreshPendingRatings = refreshPendingRatings;
document.addEventListener("DOMContentLoaded", refreshPendingRatings);
